import React, { useState, useCallback, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import styles from './AdditionCallDetailsModal.module.css'
import { Modal, Button, DropdownButton, Dropdown } from 'react-bootstrap';
import { sendMsgWithoutSavingToMongo } from '../../../store/actions';
import { useDispatch } from 'react-redux';


const AdditionCallDetailsModal = ({ telephone, onHide, show, onSave, callBackSetting }) => {
    const dispatch = useDispatch();
    const [t] = useTranslation('common');
    const [reason, setReason] = useState('Other')
    const [note, setNote] = useState()
    const [priority, setPriority] = useState(3)

    const onCloseHandler = useCallback(async () => {
        let smsMessage = '';
        const orderCompleteMsg = callBackSetting?.orderCompleteMsg;
        const genericMsgWhenFinishCallback = callBackSetting?.genericMsgWhenFinishCallback;

        if (reason === 'Order completed') {
            smsMessage = orderCompleteMsg;
        } else if (reason !== 'unit owner' && reason !== 'Not interested' && reason !== 'There is no answer') {
            smsMessage = genericMsgWhenFinishCallback;
        }
        if (smsMessage) {
            const opt = { selectedMsg: null };
            dispatch(sendMsgWithoutSavingToMongo(telephone, 'sms', smsMessage, null, opt));
        }
        onSave(t(reason), note, priority);
        onHide();
    }, [reason, note, priority, onSave, onHide, telephone, t, dispatch, callBackSetting]);
    
    // const onCloseHandler = useCallback(() => {
    //     onSave(t(reason), note, priority)
    //     onHide()
    // }, [reason, note, priority, onSave, onHide])

    const onNewNoteValue = useCallback(event => {
        const newNote = event.target.value
        setNote(newNote)
    }, [])

    useEffect(() => {
        setReason('Other')
        setNote()
        setPriority(3)
    }, [show])
    const rejectReasons = ['Order completed', 'Cancel Order', 'Answered and hung up', 'later', 'The customer will contact the operator', 'unit owner', 'Voicemail', 'Not relevant', 'Not interested', 'Other', 'There is no answer', 'Already Ordered']
    const rejectReasonsDropDownItems = rejectReasons.map((rejectReason) => <Dropdown.Item onClick={() => setReason(rejectReason)} className={styles.specificSettingsDropDownItem}>{t(rejectReason)}</Dropdown.Item>)
    const rejectPriorities = [1, 2, 3, 4, 5, 6, 7, 8, 9]
    const rejectPrioritiesDropDownItems = rejectPriorities.map((rejectPriority) => <Dropdown.Item onClick={() => setPriority(rejectPriority)} className={styles.specificSettingsDropDownItem}>{rejectPriority}</Dropdown.Item>)
    return (
        <Modal centered={true} onHide={onCloseHandler} size='md' className={`${styles.mainModal}`} show={show} >
            <Modal.Header>
                <Modal.Title>{telephone}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                <div className={styles.someSettingDiv}>
                    <div>
                        <span className={styles.specificSettingsText}>{t('reason')} </span>
                        <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={t(reason)}>
                            {rejectReasonsDropDownItems}
                        </DropdownButton>
                    </div>
                    <div>
                        <span className={`${styles['specificSettingsText']} ${styles['priority-label']}`}>{t('priority')} </span>
                        <DropdownButton className={styles['priority-dropdown']} variant='secondary' title={t(priority)}>
                            {rejectPrioritiesDropDownItems}
                        </DropdownButton>
                    </div>
                </div>
                <div className={`${styles['settings-container']} `}>
                    <label htmlFor='call-details-note' className={styles['setting-input-label']}>{t('note')}</label>
                    <textarea id='call-details-note' className={styles['setting-input']} value={note} onChange={onNewNoteValue} />
                </div>


            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={onCloseHandler}>{t('Save and close')}</Button>
            </Modal.Footer>


        </Modal>
    )
}

export default AdditionCallDetailsModal